import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ee7b84de&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ee7b84de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7b84de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee7b84de')) {
      api.createRecord('ee7b84de', component.options)
    } else {
      api.reload('ee7b84de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ee7b84de&scoped=true&", function () {
      api.rerender('ee7b84de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/components/table-settings-form/index.vue"
export default component.exports